<template>

  <span v-if="showBar" class="gas-table-toolbar" :class="{ 'is-inline': inline }">

    <el-popover

      v-if="showColumnPicker"

      placement="bottom-start"

      width="280"

      trigger="click"

      popper-class="gas-col-picker-popover"

    >

      <div class="col-picker-title">显示列（至少保留 1 列）</div>

      <el-checkbox-group v-model="checkedKeys" class="col-picker-list" @change="onCheckChange">

        <el-checkbox v-for="col in columns" :key="col.key" :label="col.key">{{ col.label }}</el-checkbox>

      </el-checkbox-group>

      <el-button slot="reference" size="small" icon="el-icon-s-operation" circle title="显示列设置" />

    </el-popover>

    <el-button

      v-if="showBatchDelete"

      size="small"

      class="btn-batch-del"

      icon="el-icon-delete"

      :disabled="!selectedCount"

      @click="$emit('batch-delete')"

    >

      批量删除{{ selectedCount ? ` (${selectedCount})` : '' }}

    </el-button>

    <slot />

  </span>

</template>



<script>

export default {

  name: 'GasTableToolbar',

  props: {

    columns: {

      type: Array,

      default: () => []

    },

    visibleMap: {

      type: Object,

      default: () => ({})

    },

    selectedCount: {

      type: Number,

      default: 0

    },

    showBatchDelete: {

      type: Boolean,

      default: true

    },

    /** 与列表标题同一行展示（默认） */

    inline: {

      type: Boolean,

      default: true

    }

  },

  data() {

    return {

      checkedKeys: []

    }

  },

  computed: {

    showColumnPicker() {

      return (this.columns || []).length > 10

    },

    showBar() {

      return this.showColumnPicker || this.showBatchDelete

    }

  },

  watch: {

    visibleMap: {

      immediate: true,

      deep: true,

      handler() {

        this.syncFromMap()

      }

    },

    columns: {

      immediate: true,

      handler() {

        this.syncFromMap()

      }

    }

  },

  methods: {

    syncFromMap() {

      const map = this.visibleMap || {}

      this.checkedKeys = (this.columns || []).filter(c => map[c.key] !== false).map(c => c.key)

    },

    onCheckChange(keys) {

      if (!keys.length) {

        this.$message.warning('至少保留一列')

        this.syncFromMap()

        return

      }

      const next = {}

      this.columns.forEach(c => {

        next[c.key] = keys.includes(c.key)

      })

      this.$emit('update:visibleMap', next)

    }

  }

}

</script>



<style scoped>

.gas-table-toolbar {

  display: flex;

  align-items: center;

  gap: 10px;

  margin-bottom: 10px;

  flex-wrap: wrap;

}

.gas-table-toolbar.is-inline {

  display: inline-flex;

  margin-bottom: 0;

  vertical-align: middle;

}

.btn-batch-del {

  color: #f53f3f;

  border-color: #f53f3f;

}

.col-picker-title {

  font-size: 13px;

  font-weight: 600;

  margin-bottom: 10px;

  color: #1d2129;

}

.col-picker-list {

  display: flex;

  flex-direction: column;

  gap: 6px;

  max-height: 320px;

  overflow-y: auto;

}

.col-picker-list >>> .el-checkbox {

  margin-right: 0;

}

</style>



<style>

.table-title-group {

  display: inline-flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 8px 12px;

  min-width: 0;

  flex: 1;

}

.table-title-group .table-title,

.table-title-group h3 {

  margin: 0;

}

.table-title-row {

  display: flex;

  align-items: center;

  flex-wrap: wrap;

  gap: 8px 12px;

  margin-bottom: 12px;

}

</style>


